import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { authService } from '../../../services/auth.service.ts';
import Meeting from '../Meeting.tsx';
import GuestJoin from '../GuestJoin.tsx';
import MeetingLinkExpired from './MeetingLinkExpired.tsx';
import { validateMeetingLinkAccess } from '../utils/meetingLinkExpiry.ts';

interface GuestData {
  name: string;
  odaId: string;
  joinedAt: string;
}

const MeetingRoute: React.FC = () => {
  const { id } = useParams();
  const [linkStatus, setLinkStatus] = useState<'loading' | 'allowed' | 'expired'>('loading');

  useEffect(() => {
    if (!id) {
      setLinkStatus('allowed');
      return;
    }

    let cancelled = false;

    void (async () => {
      const result = await validateMeetingLinkAccess(id);
      if (cancelled) return;
      setLinkStatus(result.allowed ? 'allowed' : result.expired ? 'expired' : 'allowed');
    })();

    return () => {
      cancelled = true;
    };
  }, [id]);

  if (linkStatus === 'loading') {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center text-gray-300 gap-3">
        <Loader2 className="w-5 h-5 animate-spin" />
        Toplantı kontrol ediliyor...
      </div>
    );
  }

  if (linkStatus === 'expired') {
    return <MeetingLinkExpired />;
  }

  const user = authService.getUser();

  const guestData = sessionStorage.getItem('tbkmeet_guest');
  let guest: GuestData | null = null;

  if (guestData) {
    try {
      guest = JSON.parse(guestData) as GuestData;
      if (guest && guest.odaId !== id) {
        guest = null;
        sessionStorage.removeItem('tbkmeet_guest');
      }
    } catch {
      sessionStorage.removeItem('tbkmeet_guest');
    }
  }

  if (user || guest) {
    return <Meeting />;
  }

  return <GuestJoin />;
};

export default MeetingRoute;
